import styled from 'styled-components'

export const Wrapper = styled.div`
  background: #00192B;
  border-radius: 4px;
  padding: 15px;
  margin: 0 0 24px;
`
